export default {
  actionNotPossible: 'Action not possible',
  base: 'Required entries are missing!',
  default: 'An unknown error has occurred.',
  fieldMustNotBeEmpty: 'Field must not be empty',
  nameIsTaken: 'The name is already taken',
  notFound: 'The requested resource could not be found.',
  scheduler: {
    completedFixedImmutableHint:
      'Completed or fixed events cannot be changed in time via drag and drop',
    activityAssignmentImmutableHint: "Activity isn't assigned to you",
    milestoneAssignmentImmutableHint: "Milestone isn't assigned to you",
    pauseAssignmentImmutableHint: 'You do not have permission to change Project breaks',
  },
  nameInUse: 'Name already in use',
  validation: {
    emailAlreadyExists: 'This e-mail is already in use.',
    invalidEmailFormat: 'Invalid e-mail format',
    userNotFound: 'No such member found',
  },
};
